import { render, staticRenderFns } from "./AccountSettingPayment.vue?vue&type=template&id=0c53356d&"
import script from "./AccountSettingPayment.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPayment.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports